const CustomerQuantityEnum = {
  MANY: 2,
  TWO: 1,
  ONEORNONE: 0,
}

export { CustomerQuantityEnum }
